const environment = import.meta.env.VITE_APP_ENV;

const config = {
  apiHost: import.meta.env.VITE_APP_API_HOST,
  aiMainframeHost: import.meta.env.VITE_APP_AI_MAINFRAME_HOST,
  intercomId: import.meta.env.VITE_APP_INTERCOM_APP_ID,
  placesApiKey: import.meta.env.VITE_APP_PLACES_API_KEY,
  environment,
  mcp: {
    serverUrl:
      environment === "production"
        ? "https://mcp.boompay.app/mcp"
        : "https://mcp.staging.boompay.app/mcp",
    claudeClientId: "client_01M32CFGHHWWS79378WVH9AVSP",
    chatGptClientId: "client_01M32DJKVC4NGVV1S1G5T7BHN2",
    claudeCodeClientId: "client_01M0ZQRSWY0AC1DE338YWW85Q0",
    codexClientId: "client_01M32DPK9V27WG64HKDPFB11SD"
  },
  posthog: {
    key: import.meta.env.VITE_APP_POSTHOG_KEY,
    host: "https://us.i.posthog.com"
  },
  chatInboxPromoReleaseDate: import.meta.env
    .VITE_APP_CHAT_INBOX_PROMO_RELEASE_DATE,
  stripePk: import.meta.env.VITE_APP_STRIPE_PK,
  axOrigin: import.meta.env.VITE_APP_AX_ORIGIN,
  buildId: import.meta.env.VITE_APP_SHA,
  sentryDsn: import.meta.env.VITE_APP_SENTRY_DSN,
  // The one "Book a demo" target for every BoomCRM upgrade CTA (CRM-759).
  // Marketing's talk-to-sales page with platform attribution; Jon asked for a
  // single link with no per-environment or per-button variation (Slack,
  // 2026-09-03), hence a constant rather than an env override.
  boomCrmDemoUrl:
    "https://www.boompay.app/f/talk-to-sales?utm_source=platform&utm_medium=banner&utm_campaign=platform-crm-demo"
};

export default config;
